import React from 'react';
import PropTypes from 'prop-types';

function Button(props) {
  let class_name = '';
  if (props.type === 'secondary') {
    class_name += ' button-secondary';
  }
  if (props.disabled) {
    class_name += ' button-disabled';
  }
  // No Enter key handler: a native button already turns Enter and Space into a click. The handler
  // that was here cancelled that click and called onClick directly, which hid every keyboard press
  // from the activity tracker's click listener and fired onClick even while disabled.
  return (
    <button
      style={props.custom_style}
      className={class_name}
      onClick={() => (props.disabled ? null : props.onClick())}
      tabIndex="0"
      data-track={props.track}
    >
      {props.children}
    </button>
  );
}

Button.propTypes = {
  disabled: PropTypes.bool,
  custom_style: PropTypes.object,
  onClick: PropTypes.func,
  type: PropTypes.string,
  // Names this button in CMS activity rows. Visible text is never recorded (it can hold a student's
  // name), so an untracked Button reads as "Clicked a button".
  track: PropTypes.string
};

Button.defaultProps = {
  disabled: false,
  custom_style: {},
  onClick: () => console.log('button clicked'),
  type: 'primary',
  track: undefined
};

export default Button;
